"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _mdiMaterialUi = require("mdi-material-ui");
var _UploadZone = _interopRequireDefault(require("./UploadZone"));
var _UploadList = _interopRequireDefault(require("./UploadList"));
var _Upload = _interopRequireDefault(require("./Upload.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// COMPONENTS

// ASSETS

var UploadButton = function UploadButton() {
  var theme = (0, _styles.useTheme)();
  var classes = (0, _Upload.default)();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Plus, {
    htmlColor: theme.palette.NEUTRAL200,
    fontSize: "inherit",
    style: {
      fontSize: 64
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.uploadText
  }, "Upload"));
};
var Upload = function Upload(props) {
  var _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$type = props.type,
    type = _props$type === void 0 ? 'document' : _props$type,
    children = props.children,
    _props$fileList = props.fileList,
    fileList = _props$fileList === void 0 ? [] : _props$fileList,
    onRemove = props.onRemove,
    onDownload = props.onDownload,
    onDrop = props.onDrop,
    ItemComponent = props.ItemComponent,
    accept = props.accept;

  // HOOKS
  var classes = (0, _Upload.default)();
  if (type === 'image') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.pictureWrapper
    }, /*#__PURE__*/_react.default.createElement(_UploadZone.default, {
      className: classes.pictureDropzone,
      multiple: multiple,
      onDrop: onDrop,
      accept: accept
    }, children, !children && /*#__PURE__*/_react.default.createElement(UploadButton, null)));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_UploadZone.default, {
    className: "dropzone",
    multiple: multiple,
    onDrop: onDrop,
    accept: accept
  }, children), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_UploadList.default, {
    fileList: fileList,
    onRemove: onRemove,
    onDownload: onDownload,
    ItemComponent: ItemComponent
  })));
};
var _default = Upload;
exports.default = _default;